<template>
    <div>
        <div class="col-md-10 mx-auto">
            <div class="card mt-5" v-cloak>
                <div class="card-header bg-primary text-white">
                    <page-title :title="$t('sideMenu.formActivation')"></page-title>
                </div>
                <div class="card-body">
                    <div v-cloak>
                        <div class="input-group col-sm-3 float-right">
                            <div class="input-group-addon fa fa-search" style="display:table-cell"></div>
                            <input class="form-control fa fa-search" name="query" v-model="searchQueryFormsToEvent">
                        </div>
                    </div>
                    <custom-grid :data="formToEventItems"
                                 :columns="formsToEventgridColumns"
                                 :filter-key="searchQueryFormsToEvent"
                                 :captions="formsToEventgridCaptions"
                                 :gridName="'FormsToEvent'">
                    </custom-grid>
                    <button v-if="hasEditRights" type="button" class="btn btn-primary btn" :class="saving ? 'disabled' : ''" @click.stop="activateForm">
                        <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                        <i class="fas fa-save" v-else></i>
                        {{ $t('buttons.save.btnText') }}
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import PageTitle from '../../../../components/common/PageTitle';
    import CustomGrid from "../../../../components/grid/CustomGrid";
    import { FormToEvent } from '../../../../models/models';

    export default {
        inject: ['$validator'],
        components: {
            PageTitle,
            CustomGrid
        },
        props: {

        },
        data() {
            return {
                saving: false,
                formToEventItems: [],
                searchQueryFormsToEvent: '',
                formsToEventgridCaptions: {
                    checked: '',
                    name: 'registers.forms.formToEvent.gridHeaders.name',
                    nameEn: 'registers.forms.formToEvent.gridHeaders.nameEn',
                    formType: 'registers.forms.formToEvent.gridHeaders.formType',
                    formTypeEn: 'registers.forms.formToEvent.gridHeaders.formTypeEn',
                    note: 'registers.forms.formToEvent.gridHeaders.note',
                    validFromUtc: 'registers.forms.formToEvent.gridHeaders.validFromUtc',
                    validToUtc: 'registers.forms.formToEvent.gridHeaders.validToUtc'
                },
                formsToEventgridColumns: ['checked', 'name', 'formType', 'note', 'validFromUtc', 'validToUtc'],
            }
        },
        methods: {
            loadFormsToEvent() {
                this.$http.get('/api/dynamicForms/formsToEvent', {
                    params: {
                        eventId: 0
                    }
                })
                    .then((response) => {
                        if (Array.isArray(response.data.items) && response.data.items.length > 0) {
                            response.data.items.forEach((item, index) => {
                                this.formToEventItems.push(new FormToEvent(item));
                            });
                        }

                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
            },
            activateForm() {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.saving = true;

                let items = this.formToEventItems.filter(form => form.checked);
                this.$http.post('/api/DynamicForms/activate', items).then((response => {
                    this.$vs.notify({
                        title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                        text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    });

                    this.saving = false;

                })).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });

                    this.saving = false;
                });
            }
        },
        computed: {
            hasEditRights() {
                return this.$store.getters.claims.dynamicRegister.create
                    || this.$store.getters.claims.dynamicRegister.update;
            },
        },
        mounted() {
            this.loadFormsToEvent();
        }
    }
</script>
